// extracted by mini-css-extract-plugin
module.exports = {"button":"_ec96b5a8","icon":"_aeb6e375","disabled":"_ca0eb0ce","noText":"_c3f05422","text":"_dc3e5723","upperCase":"_6c14248"};